<template>
  <div class="container center-align">
    <main>
      <!-- Add two inputs for "phoneNumber" and "code" -->
      <!-- <input type="tel" id="phoneNumber" v-model="user.num" />
      <input type="text" id="code" v-model="user.code" />-->

      <!-- Add two buttons to submit the inputs -->
      <!-- <button id="sign-in-button" @click="submitPhoneNumberAuth">SIGN IN WITH PHONE</button>
      <button id="confirm-code" @click="submitPhoneNumberAuthCode">ENTER CODE</button>-->

      <!-- Add a container for reCaptcha -->
      <!-- <div id="recaptcha-container"></div> -->
      <div>
        <img class="mb-4" src="../assets/logo1.jpeg" style="border-radius: 50px; background: white none repeat scroll 0% 0%;" alt width="100" height="100" />
        <img class="mb-4" src="../assets/logo2.jpeg" style="border-radius: 50px; background: white none repeat scroll 0% 0%;" alt width="100" height="100" />
        <h1 class="h3 mb-3 font-weight-normal">Mobile Authentication</h1>
        <div class="alert alert-danger" v-if="user.status">{{user.status}}</div>
        <label for="inputEmail" class="sr-only">Phone Number</label>
        <input
          type="tel"
          id="phoneNumber"
          class="form-control"
          placeholder="Enter your 10 digit mobile number"
          required
          autofocus
          v-model="user.num"
        />
        <label for="inputPassword" class="sr-only">Password</label>
        <input
          type="text"
          id="code"
          class="form-control"
          placeholder="OTP"
          required
          v-model="user.code"
          v-show="user.entercode"
        />
        <div class="mb-3">
          <div id="recaptcha-container" v-show="user.captcha"></div>
        </div>

        <button
          id="sign-in-button"
          class="btn btn-block waves-effect blue darken-1 waves-light"
          @click="submitPhoneNumberAuth"
          v-show="user.phNumEntered"
          :disabled="user.num.length<10"
        >Get OTP</button>
        <button
          id="confirm-code"
          class="btn btn-block waves-effect blue darken-1 waves-light"
          @click="submitPhoneNumberAuthCode"
          v-show="user.entercode"
        >ENTER CODE</button>

        <p class="mt-5 text-muted">&copy; 2017-2020</p>
      </div>
    </main>
  </div>
</template>

<script>
import firebase from "firebase";
export default {
  data() {
    return {
      user: {
        num: "",
        code: "12345",
        status: "",
        captcha: true,
        entercode: false,
        phNumEntered: true,
      },
    };
  },
  methods: {
    
    submitPhoneNumberAuth() {
      // We are using the test phone numbers we created before
      // var phoneNumber = document.getElementById("phoneNumber").value;
      var phoneNumber = "+1" + this.user.num;
      var appVerifier = window.recaptchaVerifier;
      firebase
        .auth()
        .signInWithPhoneNumber(phoneNumber, appVerifier)
        .then((confirmationResult) => {
          console.log("1here");
          window.confirmationResult = confirmationResult;
          this.user.entercode = true;
          this.user.phNumEntered = false;
        })
        .catch(function (error) {
          console.log("2here");
          console.log(error);
        });
    },
    submitPhoneNumberAuthCode() {
      // We are using the test code we created before
      // var code = document.getElementById("code").value;
      var code = this.user.code;
      confirmationResult
        .confirm(code)
        .then((result) => {
          var user = result.user;
          console.log("3here");
          console.log(user);
          this.$store.state.phno = this.user.num;
          this.$router.push("/aboutme");
        })
        .catch((error) => {
          this.user.status =
            "Entered OTP is wrong, Please enter the correct OTP.";
          console.log("4here");
          console.log(error);
        });
    },
  },
  mounted() {
    console.log(this.user.num.length);
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "normal",
        callback: (response) => {
          console.log("here");
          console.log(response);
          this.user.captcha = false;
        },
      }
    );
  },
  beforeUpdate() {
    console.log("Why");
  },
};
</script>

<style>

</style>

  